import React, { Component } from 'react';
import { connect }        from 'react-redux';
import $                  from 'jquery';
import Avata_p              from '../../../../container/render_avatar_p';

class batalha_jogo_fim extends Component {

	constructor(props){

        super(props);
        this.state = {
                         texto            : "",
                         textResultado    : "",
						 nomeDesafiante   : "",
						 nomeDesafiado    : "",
						 fotoDesafiante   : "",
						 fotoDesafiado    : "",
						 pontoDesafiante  : "",
						 pontoDesafiado   : "",
						 classeDesafiante : "",
						 classeDesafiado  : "",
						 porcentagemDesafiante:"",
						 porcentagemDesafiado:"",
						 limit:3
                     }
   }


   componentWillMount(){

	const object = this.props.allQuestaoJogo;
	const xp     = object.pon_ger_porcentagem_xp;
	if(object.dadosPontuacao){
		$('.hud-bottom-center-side .pontos').html(object.dadosPontuacao.pon_ger_pontos);
		$('.hud-bottom-center-side .nivel').html(object.dadosPontuacao.pon_ger_nivel);
		$('#progress-label').text(`${xp}%`);
		$('.progress-4').css('width',`${xp}%`);
		$('.progress-5').css('width',`${xp}%`);
		localStorage.setItem('pontuacao',JSON.stringify(object.dadosPontuacao));		
	}

	var obj = {};
	switch(object.statusDuelo) {
	
		case 1:
		  obj={
				texto:`Você acertou ${object.pontos} de ${this.state.limit} questões! Aguarde o seu oponente para saber o resultado final do duelo.`,
			    nomeDesafiante:object.dados.use_nome,
				pontoDesafiante:object.pontos,
				textResultado:"Aguardando...",
				fotoDesafiante: <Avata_p Foto={object.dados.use_foto}/>
			  }

		  this.setState(obj)
		
		break;
		
		case 2:
			
				 switch(this.props.session.id) {
					
					 case object.desafiante.use_id:
							 console.log('desafiante');
							if(object.desafiante.pontos>object.desafiado.pontos){
								console.log('Você ganhou!');
							   //Você ganhou! 
							   obj.texto            = `Parabéns!!! Você acertou ${object.desafiante.pontos} de ${this.state.limit} questões.`;
							   obj.classeDesafiante = "battle-card-progress-bar-success";
							   obj.classeDesafiado  = "battle-card-progress-bar-error";
							
							}

							if(object.desafiante.pontos<object.desafiado.pontos){
								console.log('Você perdeu!');
								//Você perdeu! 
								obj.texto = `Não foi dessa vez! Você acertou ${object.desafiante.pontos} de ${this.state.limit} questões.`;
								obj.classeDesafiante = "battle-card-progress-bar-error";
								obj.classeDesafiado  = "battle-card-progress-bar-success";									 
							}

							if(object.desafiante.pontos===object.desafiado.pontos) {
								 console.log('Você empatou!');
								 //Você empatou
								 obj.texto = `Houve empate nesse duelo! Você acertou ${object.desafiante.pontos} de ${this.state.limit} questões.`;
								 obj.classeDesafiante = "";
								 obj.classeDesafiado  = "";		
							}

					 break;
				  
					 case object.desafiado.use_id:
					   
						   console.log('desafiado');
						   if (object.desafiado.pontos>object.desafiante.pontos) {
								 console.log('Você ganhou!');
								 obj.texto =`Parabéns!!! Você acertou ${object.desafiado.pontos} de ${this.state.limit} questões. Sua pontuação será calculada quando o seu oponente concluir a batalha.`;
								 obj.classeDesafiante = "battle-card-progress-bar-success";
								 obj.classeDesafiado  = "battle-card-progress-bar-error";											
							}

						   if (object.desafiado.pontos<object.desafiante.pontos) {
								 console.log('Você perdeu!');
								 obj.texto =`Não foi dessa vez! Você acertou ${object.desafiado.pontos} de ${this.state.limit} questões.`;
								 obj.classeDesafiante = "battle-card-progress-bar-error";
								 obj.classeDesafiado  = "battle-card-progress-bar-success";										  
							}

							if (object.desafiado.pontos===object.desafiante.pontos) {
								 console.log('Você empatou!');
								 obj.texto =`Houve empate nesse duelo! Você acertou ${object.desafiado.pontos} de ${this.state.limit} questões.`;
								 obj.classeDesafiante = "";
								 obj.classeDesafiado  = "";										  
							} 
					break;
					
					 default:
					 break;
				 }

				const pont1 =object.desafiante.pontos;
				const pont2 =object.desafiado.pontos;
				const ponstosDesafiante = (pont1>0?eval(`${pont1}0/0.${this.state.limit}`):"");
				const ponstosDesafiado  = (pont2>0?eval(`${pont2}0/0.${this.state.limit}`):"");

				this.setState({
								nomeDesafiante        : object.desafiante.use_nome,
								nomeDesafiado         : object.desafiado.use_nome,
								pontoDesafiante       : object.desafiante.pontos,
								pontoDesafiado        : object.desafiado.pontos,
								fotoDesafiante        : <Avata_p Foto={object.desafiante.use_foto}/>,
								fotoDesafiado         : <Avata_p Foto={object.desafiado.use_foto}/>,
								texto                 : obj.texto,
								classeDesafiante      : obj.classeDesafiante,
								classeDesafiado       : obj.classeDesafiado,
								porcentagemDesafiante : ponstosDesafiante,
								porcentagemDesafiado  : ponstosDesafiado
						});
		   

	}

	
}

	
    render() {
	
		const porc1 = {"width": `${this.state.porcentagemDesafiante}%`}
		const porc2 = {"width": `${this.state.porcentagemDesafiado}%`}

        return (
           <div className="battle">
		<div className="battle-title battle-title-spaced">
			<div className="battle-title-info">
				<div className="battle-title-squares">
					<div className="battle-title-square battle-title-square-success"></div>
					<div className="battle-title-square battle-title-square-error"></div>
					<div className="battle-title-square battle-title-square-success"></div>
				</div>
			</div>
			<div className="battle-title-text battle-title-text-small battle-title-text-centered">
			{this.state.texto}
			</div>
		</div>
		<div className="battle-cards">
		<div className="battle-card">
				<div className="battle-card-head">
					<div className="battle-card-avatar">
					{this.state.fotoDesafiante}
					</div>
					<div className="battle-card-info">
						<div className="battle-card-info-name">{this.state.nomeDesafiante}</div>
						<div className="battle-card-info-extra">Turma F02453658</div>
					</div>
				</div>
				<div className="battle-card-progress">
					<div className="battle-card-progress-label">{`${this.state.pontoDesafiante}/${this.state.limit}`}</div>
					<div className="battle-card-progress-container-bar">
						<div className={`battle-card-progress-bar ${this.state.classeDesafiante}`} style={porc1}>
						{this.state.textResultado}
						</div>
					</div>
				</div>
			</div>	
			{this.props.allQuestaoJogo.statusDuelo ==2? 
			<div className="battle-card">
				<div className="battle-card-head">
					<div className="battle-card-avatar">
					{this.state.fotoDesafiado}
					</div>
					<div className="battle-card-info">
						<div className="battle-card-info-name">{this.state.nomeDesafiado}</div>
						<div className="battle-card-info-extra">Turma F02453658</div>
					</div>
				</div>
				<div className="battle-card-progress">
					<div className="battle-card-progress-label">{`${this.state.pontoDesafiado}/${this.state.limit}`}</div>
					<div className="battle-card-progress-container-bar">
						<div className={`battle-card-progress-bar ${this.state.classeDesafiado}`} style={porc2}></div>
					</div>
				</div>
			</div>	
			 :""}
		</div>
	</div>
        );
    }
}

function mapStateToProps(state) {

    return { 
            session        : state.auth.session,
            menu           : state.configReducer.menu,
            allQuestaoJogo : state.questaoReducer.allQuestaoJogo,
           }
}

export default connect(mapStateToProps)(batalha_jogo_fim);


	{/* <div className="battle-card-progress-bar battle-card-progress-bar-error" style="width: 40%"></div> */}


// WEBPACK FOOTER //
// ./src/components/aluno/batalha/jogo/batalha_jogo_fim.js